<template>
  <div class="my-company-dailog" v-if="show">
    <div class="my-company-mask" @click="close"></div>
    <div class="my-company-body">
      <ul class="my-company-list">
        <li class="my-company-item" @click="checkItem(item)" :key="item.id" v-for="item in list"><span class="my-company-fl my-company-ellipsis" :class="activeItem==item.id?'company-fl-active':''">{{item.orgName}}</span><span class="my-company-fr" v-if="activeItem==item.orgId"><i class="el-icon-success success-col"></i></span></li>
      </ul>
    </div>
  </div>
</template>
<script>
  
  import { mapState } from 'vuex'
  import { get, remove, set } from "js-cookie";
  export default {
    props: ['show','list','listValue'],
    data () {
      return {
        activeItem:'',
        listData:[],
        protocol:"onelinkplus.com"
      }
    },
    computed:{
      ...mapState([
        'KP'
      ])
    },
    components: {
    },
    created () {
    },
    mounted () {
      console.info(this.list)
      this.activeItem=this.listValue
    },
    watch:{
      list(){
        return this.list||[]
      },
      listValue(){
        this.activeItem=this.listValue
      }
    },
    methods: {
      close(){
        this.$emit('closeDailog')
      },
      checkItem(item){
        this.activeItem=item.orgId
        this.switvhCompany(item)
      },
      switvhCompany(item){
        
        this.$axios.post('/onelink.mdata.main.api/user/switvhCompany', {
          companyId: item.orgId,
          rememeberPassword: true,
          userId: item.userId
        }).then(
          // (res) => {
          //   console.info(res.data)
          
          //   window.location.reload()
          // }
          ({
            isCompanyManager,
            checkFlag,
            loginFlag,
            errorInfo,
            checkCardInfo,
            checkIsWanbangGroup,
            checkIsFosunGroup
          }) => {

            // let userInfo = this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv) || "{}"
            // userInfo = JSON.parse(userInfo)
            // this.setToken('userInfo',this.getAesString(JSON.stringify({...userInfo,companyName:item.orgName,companyId:item.orgId}),this.KP.key,this.KP.iv));
         

            // set("companyName", item.orgName, {
            //   domain: this.protocol,
            //   expires: 1 / 48
            // });
            // console.log(checkIsWanbangGroup);
            // this.setCookie("isLogin", 100);
            // this.setCookie("isCompanyManager", isCompanyManager ? 100 : "");
            // this.setCookie("checkIsWanbangGroup", checkIsWanbangGroup ? '0' : '1');
            // this.setCookie("checkIsFosunGroup", checkIsFosunGroup ? '0' : '1');

            // if (loginFlag) {
            //   this.setCookie("checkFlag", checkFlag ? 100 : 200);
            //   this.setCookie("examineStatus", "");
            //   this.setCookie("exmaineMessage", "");
            // } else {
            //   this.setCookie(
            //     "examineStatus",
            //     errorInfo === "该账户正在审核中"
            //       ? "200"
            //       : errorInfo === "该账户审批未通过"
            //       ? "300"
            //       : get("examineStatus")
            //   );
            //   errorInfo === "该账户审批未通过" &&
            //     this.setCookie(
            //       "exmaineMessage",
            //       checkCardInfo ? checkCardInfo.checkRemark || "" : ""
            //     );
            // }

            // window.location.reload();
            set("justId", item.orgId, {
              domain: this.protocol,
              expires: 1 / 48
            });
            set("companyName", item.orgName, {
              domain: this.protocol,
              expires: 1 / 48
            });
            this.$emit('changeItem',item)
            this.$emit('closeDailog')
            window.location.reload();
          }
        ).catch((err) => {
          console.log(err)
        })
      }

    }
  }
</script>
<style>
  .my-company-dailog{
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    z-index: 999;
  }
  .my-company-dailog .my-company-mask{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
  }
  .my-company-dailog .my-company-body{
    position: relative;
    background: #fff;
    z-index: 2;
    max-height: 510px;
    overflow-y: auto;
  }
  .my-company-dailog .my-company-list{
    padding: 0 15px;
  }
  .my-company-dailog .my-company-item{
    padding: 14px 0;
    line-height: 22px;
    border-bottom: 1px solid #E6E8EB;
    clear: both;
    overflow: hidden;
  }
  .my-company-dailog .my-company-item .my-company-fr{
    float:right;
  }
  .my-company-dailog .my-company-item .my-company-fl{
    float:left;
  }
  .my-company-dailog  .my-company-list li:last-child{
    border:0;
  }
  .my-company-dailog .my-company-item .company-fl-active{
    font-weight: bold;
  }
  .my-company-dailog .my-company-item .my-company-ellipsis{
    display: inline-block;
    width: 78%;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
    text-overflow:ellipsis;
  }
</style>


// WEBPACK FOOTER //
// src/pages/dingWorkbench/components/companyChange.vue